import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';

export function useUserMappings() {
  const { userMappingService } = useService();

  const { data, isFetching } = useQuery([QUERY_KEYS.userMappings], () => userMappingService.getUserMappings());

  return { userMappings: data, isFetching } as const;
}
